import { createReducer } from '@mews/framework';
import {
    META_STATE_SUCCEEDED,
    META_STATE_FAILED,
    META_STATE_STARTED,
} from '@mews-commander/legacy-entities/src/constants';
import {
    EMBEDDED_TOKEN_FETCHING_STARTED,
    EMBEDDED_TOKEN_FETCHING_FAILED,
    EMBEDDED_TOKEN_FETCHING_SUCCEEDED,
    EMBEDDED_TOKEN_CONFIGURATION_FETCHING_STARTED,
    EMBEDDED_TOKEN_CONFIGURATION_FETCHING_FAILED,
    EMBEDDED_TOKEN_CONFIGURATION_FETCHING_SUCCEEDED,
    POWERBI_ANALYTICS_TYPE_SET,
    EMBEDDED_TOKEN_CLEARED,
    DATA_INTEGRITY_VIOLATED,
    UPDATE_EVENT_TIMER,
} from '../actions';
import { CoreState, EventTimer, WithAnalyticsType } from '../types';

const initialState: CoreState = {
    embeddedToken: null,
    groupId: null,
    reportId: null,
    datasetId: null,
    analyticsType: null,
    dataIntegrityConfirmed: true,
    runningEventTimer: null,
    firstRender: true,
    ...META_STATE_SUCCEEDED,
};

export default createReducer(initialState, {
    [EMBEDDED_TOKEN_FETCHING_STARTED]: (state: CoreState) => ({
        ...state,
        ...(state.embeddedToken ? META_STATE_SUCCEEDED : META_STATE_STARTED),
    }),
    [EMBEDDED_TOKEN_FETCHING_FAILED]: (state: CoreState) => ({
        ...state,
        ...META_STATE_FAILED,
    }),
    [EMBEDDED_TOKEN_FETCHING_SUCCEEDED]: (state: CoreState, { embeddedToken }: { embeddedToken: string }) => ({
        ...state,
        embeddedToken,
        ...META_STATE_SUCCEEDED,
    }),
    [EMBEDDED_TOKEN_CLEARED]: (state: CoreState) => ({
        ...state,
        embeddedToken: null,
    }),
    [EMBEDDED_TOKEN_CONFIGURATION_FETCHING_STARTED]: (state: CoreState) => ({
        ...state,
        ...META_STATE_STARTED,
    }),
    [EMBEDDED_TOKEN_CONFIGURATION_FETCHING_FAILED]: (state: CoreState) => ({
        ...state,
        ...META_STATE_FAILED,
    }),
    [EMBEDDED_TOKEN_CONFIGURATION_FETCHING_SUCCEEDED]: (
        state: CoreState,
        { groupId, reportId, datasetId }: { groupId: string; reportId: string; datasetId: string }
    ) => ({
        ...state,
        groupId,
        reportId,
        datasetId,
        ...META_STATE_SUCCEEDED,
    }),
    [POWERBI_ANALYTICS_TYPE_SET]: (state: CoreState, { analyticsType }: WithAnalyticsType) => ({
        ...state,
        analyticsType,
        runningEventTimer: null,
        firstRender: true,
    }),
    [DATA_INTEGRITY_VIOLATED]: (state: CoreState) => ({
        ...state,
        dataIntegrityConfirmed: false,
    }),
    [UPDATE_EVENT_TIMER]: (state: CoreState, { runningEventTimer, firstRender }: EventTimer) => ({
        ...state,
        runningEventTimer,
        firstRender,
    }),
});
